// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_8B6","importantInfo":"styles_importantInfo__14BYj"};